module.exports = __webpack_public_path__ + "static/media/Level_one.409580c4.svg";